import dayjs from 'dayjs';
import { base64ToFile } from '@/utils/GenerateFileFromBase64';
import MroService from '@/domain/Mro/MroService';

const mroService = new MroService();

export const useReportGenerator = (
  selectedDate: any,
) => {
  const generateReport = async (selectedSensors: any[]) => {
    const [startDate, endDate] = selectedDate;

    const formattedStartDate = dayjs(startDate).format('YYYYMMDDTHHmm');
    const formattedEndDate = dayjs(endDate).format('YYYYMMDDTHHmm');

    const fileName = `Report -${formattedStartDate} to ${formattedEndDate}.xlsx`;

    const outfall = selectedSensors.map((sl) => ({
      infrastructureId: sl.infrastructureId,
      paramId: sl.measurementTargetId,
      sourceId: sl.sourceId,
    }));

    const response = await mroService.getMROReport({
      startDate: dayjs(startDate).format('YYYY-MM-DD HH:mm:ss'),
      endDate: dayjs(endDate).format('YYYY-MM-DD HH:mm:ss'),
      infrastructure: outfall,
    });

    base64ToFile(response, fileName);
  };

  return { generateReport };
};
